// src/auth/refreshManager.js
let refreshPromise = null;

export function hasValidRefreshToken() {
  const rt = localStorage.getItem('refresh_token');
  return !!rt && rt !== 'undefined' && rt !== 'null' && rt !== 'false';
}

export function ensureRefresh(store) {
  if (!refreshPromise) {
    refreshPromise = store.dispatch('refreshAccessToken')
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}
